import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ARService} from '../../ar/ar.service';
import {CaseFormsService} from '../case-forms.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Globals} from '../../../globals';
import {FinalReportService} from '../../../services/final-report.service';
import {PatientCaseEndoFinalReportDataModel} from '../../../models/finalReport/patient-case-endo-final-report-data.model';
import {TdoNoteQueryModel} from '../../../main-interface/controls/tdo-notes/models/tdo-note-query.model';
import {NoteCategoryEnum} from '../../../models/enum/note-category.enum';
import {NoteTypeEnum} from '../../../models/enum/note-type.enum';
import {NotesService} from '../../../services/notes.service';
import {NoteDataModel} from '../../../models/notes/note-data.model';
import {PatientCaseEndoFinalReportNoteModel} from '../../../models/finalReport/patient-case-endo-final-report-note.model';
import {TdoTableSelectionEvent} from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';


@Component({
  selector: 'app-case-final-report-select',
  templateUrl: './case-final-report-select.component.html',
  styleUrls: ['./case-final-report-select.component.scss']
})
export class CaseFinalReportSelectComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<CaseFinalReportSelectComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public noteService: NotesService,
    private arService: ARService,
    private caseService: CaseFormsService,
    private finalReportService: FinalReportService,
    private snackBar: MatSnackBar,
    public globals: Globals,
  ) {}

  PatientID: string;
  FinalReportNotes: PatientCaseEndoFinalReportNoteModel[] = [];
  FinalReportNote: PatientCaseEndoFinalReportNoteModel;
  SelectedFinalReport: PatientCaseEndoFinalReportDataModel;
  note: NoteDataModel;
  isLoading: boolean = false;
  searchPredicate: any;

  ngOnInit() {
    this.PatientID = this.data.PatientId;
    this.init();
  }

  init() {

    this.isLoading = true;

    if (this.PatientID) {
      this.finalReportService.getFinalReportsForPatient(this.globals.currentPatientId).subscribe((data) => {
          const result = data;
          this.FinalReportNotes = result;
          this.isLoading = false;
        },
        error => {
          this.isLoading = false;
          this.createMessage('Problem loading final report list', 'Error');
        }
      );
    }
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  selectReport() {
    this.dialogRef.close(this.FinalReportNote);
  }

  cancel(payload) {
    this.dialogRef.close(payload);
  }

  onRowSelected(event: TdoTableSelectionEvent) {
    this.FinalReportNote = event.model;
  }
}
